/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

/** @type {AllCollapsedContext} */
const defaultContext = {};

export const AllCollapsedContext = createContext(defaultContext);

/**
 * @typedef {object} AllCollapsedContext
 * @property {boolean | null} allCollapsed - Can be one of three states: true, false, or null
 * @property {() => void} expandAll - Sets allCollapsed to false
 * @property {() => void} collapseAll - Sets allCollapsed to true
 * @property {() => void} clearCollapse - Sets allCollapsed to null so we can trigger collapse/expand again
 */
